import { render, staticRenderFns } from "./SettingsRuleFile.vue?vue&type=template&id=2cba75e5&scoped=true&"
import script from "./SettingsRuleFile.vue?vue&type=script&lang=js&"
export * from "./SettingsRuleFile.vue?vue&type=script&lang=js&"
import style0 from "./SettingsRuleFile.vue?vue&type=style&index=0&id=2cba75e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba75e5",
  null
  
)

export default component.exports